export default __webpack_public_path__ + "8d52b8aa8b92dc03cfe70f0679ad0796.svg";